









import Vue from "vue";
export default Vue.extend({
  name: "VoteBadge",
  props: {
    value: {
      required: true,
      type: Boolean,
    },
  },
});
